function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRauchmelder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "black",
    strokeWidth: 2,
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeLinecap: "round"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,23.5L23.5,23.5",
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5,23.5L23.5,1.5",
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5,1.5L1.5,1.5",
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,1.5L1.5,23.5",
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.353,6.453L10.452,10.549",
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.452,10.549L14.548,14.451",
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.548,14.451L10.647,18.547",
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRauchmelder);
export default __webpack_public_path__ + "static/media/rauchmelder.97a95681da750e5ba0138a585d9673e3.svg";
export { ForwardRef as ReactComponent };